import { createAction } from "@reduxjs/toolkit";
import type { UpdateTeacherTeachingBody } from "@shared-kernel/application/ports/teacher/teacher-repository";
import { createApiThunk } from "@shared-kernel/application/create-api-thunk";

export const updateTeacherTeaching = createApiThunk<void, UpdateTeacherTeachingBody>(
  "teachers/updateTeacherTeaching",
  async (body, { extra: { teacherRepository } }) => {
    return teacherRepository!.updateTeaching(body);
  },
);

export const resetUpdateTeacherTeaching = createAction("teachers/resetUpdateTeacherTeaching");
